import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

import { IMAGE_URLS } from "../../../constants";
import LZLoader from "../../../commonComponents/LZLoader";

const { RECIPIENT_EMPTY_FIELDS } = IMAGE_URLS;

const unfilledFormHeader = docFlow => {
  let value = "";
  if (docFlow === "ACCEPTANCE") {
    value = (
      <span>
        If you want to review the document and fill these fields, go{" "}
        <b> Back </b>. If you are done, please{" "}
        <b>
          <em>Submit</em>
        </b>
        . You will receive an email shortly with a link to accept the document.
      </span>
    );
  } else {
    value = (
      <span>
        If you want to review the document and fill these fields, click{" "}
        <b>
          <em>Back.</em>
        </b>{" "}
        To proceed to eSignature, click{" "}
        <b>
          <em>Submit anyway.</em>
        </b>
      </span>
    );
  }
  return value;
};

const unfilledFormLoaderText = docFlow => {
  let value = "🔏Processing your document for eSignature";
  if (docFlow === "ACCEPTANCE") {
    value = "🔏Processing document for acceptance";
  }
  return value;
};

const UnfilledFormFieldsPopup = ({
  onConfirm,
  onClose,
  isLoading,
  unfilledValue,
  docFlow,
}) => (
  <Modal
    classNames={{
      modal: "recipientdocinfopopup-modal",
      closeButton: "modal-close-btn-mobile-view",
    }}
    open
    onClose={onClose}
    center
    closeOnOverlayClick={false}>
    {isLoading && (
      <LZLoader
        className="loader-bg-color recipient-loader recipient-submit-loader"
        label={` ${
          isLoading ? `${unfilledFormLoaderText(docFlow)}` : "Loading..."
        }`}
      />
    )}
    <div className="recipientdocinfopopup-container">
      {/* ------ Recipient document info header(gif, recipient title and send info) section ------ */}
      <div className="recipientdocinfopopup-header recipient-white-bg">
        <div className="recipientdocinfopopup-img-wrapper">
          <img
            src={RECIPIENT_EMPTY_FIELDS}
            alt="form-mode-check"
            className="recipientdocinfopopup-img"
          />
        </div>
        <div className="recipientdocinfopopup-recipient-title">
          You have {unfilledValue} unfilled form field(s)
        </div>
        <div className="recipientdocinfopopup-sender-info unfilled-info">
          {unfilledFormHeader(docFlow)}
        </div>
      </div>

      <div className="unfilled-form-popup-footer">
        <Button
          data-test="back-to-document-button"
          className="unfilled-form-popup-btn-inherit"
          onClick={onClose}
          onKeyPress={() => {}}>
          Back
        </Button>
        <Button
          type="four"
          data-test="submit-anyway-button"
          className="revv-btn-primary"
          onClick={onConfirm}
          onKeyPress={() => {}}>
          {docFlow === "ACCEPTANCE" ? "Submit" : "Submit anyway"}
        </Button>
      </div>
    </div>
  </Modal>
);
export default UnfilledFormFieldsPopup;
